import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const BASE = "/api/v1/erp/barcode";

export const resolveBarcode = createAsyncThunk(
  "barcode/resolve",
  async (code: string): Promise<any> => {
    // Silent: the caller shows its own toast, so skip the global error interceptor's
    // toast (avoids a duplicate on the 404 "unknown barcode" case).
    const response = await axios.get(`${BASE}/resolve?code=${encodeURIComponent(code)}`, {
      headers: { "x-silent": "1" },
    });
    return response.data;
  }
);

export const mapBarcode = createAsyncThunk(
  "barcode/map",
  async (payload: { skuId: string; code: string; symbology?: string; batchId?: string; isPrimary?: boolean }): Promise<any> => {
    const response = await axios.post(`${BASE}/map`, payload);
    return response.data;
  }
);

export const generateSkuBarcode = createAsyncThunk(
  "barcode/generate",
  async (payload: { skuId: string; batchId?: string; isPrimary?: boolean }): Promise<any> => {
    const response = await axios.post(`${BASE}/generate`, payload);
    return response.data;
  }
);

export const fetchBarcodeMappings = createAsyncThunk(
  "barcode/mappings",
  async (skuId: string): Promise<any> => {
    const response = await axios.get(`${BASE}/mappings?skuId=${skuId}`);
    return response.data;
  }
);

export const deleteBarcodeMapping = createAsyncThunk(
  "barcode/deleteMapping",
  async (id: string): Promise<any> => {
    const response = await axios.delete(`${BASE}/mappings/${id}`);
    return response.data;
  }
);
